export const draftlessId = (id: string) => id.replace(/^drafts\./, "");
export const languagelessId = (id: string) => id.replace(/_[^_]*$/, "");
export const normalizedId = (id: string) => draftlessId(languagelessId(id));
export const languageFromId = (id: string) => {
  const match = /_([^_]*)$/.exec(id);
  if (match && match[1]) {
    return match[1];
  }
  return "en";
};
